module.exports = __webpack_public_path__ + "img/14.af7e5ebd.png";